module.exports = __webpack_public_path__ + "img/camera.444a3187.svg";